import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function Payment() {
  const [payment, setPayment] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // ✅ use navigate instead of window.location
    const token = localStorage.getItem("token");

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this payment?")) return;

    try {
      const { data } = await apiClient.delete(ADMIN.DELETE_PAYMENT(id));
      if (data.success) {
        toast.success(data.message || "Payment deleted successfully");
        setPayment((prev) => prev.filter((p) => p._id !== id));
      } else {
        toast.error(data.message || "Failed to delete payment");
      }
    } catch (err) {
      console.error("Error deleting:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to delete payment");
    }
  };

  // ✅ Edit payment
  const handleEdit = (paymentData) => {
    // Option 1: Navigate with query param
    navigate(`/addpayment?id=${paymentData._id}`);

    // Option 2: open a modal pre-filled with paymentData
  };

  useEffect(() => {
    const fetchpayment = async () => {
      try {
        const { data } = await apiClient.get(ADMIN.GET_PAYMENT);
        if (data.success) {
          setPayment(data.items);
        }
      } catch (err) {
        console.error("Error fetching payment:", err);
        toast.error(err.response?.data?.message || err.message || "Failed to fetch payments");
      } finally {
        setLoading(false);
      }
    };

    fetchpayment();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title"> Payment Tables </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Dashboard</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Payment Table
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-10">
                    <h4 className="card-title">Payment Data</h4>
                  </div>
                  {/* <div className="col-2">
                    <a href="./addpayment">
                      <button className="btn-primary">Add Item</button>
                    </a>
                  </div> */}
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> Serial No </th>
                        <th> Order Id </th>
                        <th> Customer Id </th>
                        <th> Amount </th>
                        <th> Method </th>
                        <th> Transaction Id </th>
                        <th> Status </th>
                        <th> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : payment.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No payments found
                          </td>
                        </tr>
                      ) : (
                        payment.map((t, index) => (
                          <tr key={t._id}>
                            <td>{index + 1}</td>
                            <td>{t.order_id}</td>
                            <td>{t.customer_id}</td>
                            <td>{t.amount}</td>
                            <td>{t.method}</td>
                            <td>{t.transaction_id}</td>
                            <td>{t.status}</td>
                            <td>
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(t._id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payment;
